const R_VAL_Stv = (itm, temp) => {

console.log('R_VAL_Stv VIT_INV_AMT_FCX: '+document.getElementsByName('VIT_INV_AMT_FCX')[0].value);


temp.INV=document.getElementsByName('VIT_INV_AMT_FCX')[0].value.replace(/,/g, "")*document.getElementsByName('VIT_INV_CUR_RAT')[0].value.replace(/,/g, "");
temp.EFR=document.getElementsByName('VIT_EFR_AMT_FCX')[0].value.replace(/,/g, "")*document.getElementsByName('VIT_EFR_CUR_RAT')[0].value.replace(/,/g, "");
temp.IFR=document.getElementsByName('VIT_IFR_AMT_FCX')[0].value.replace(/,/g, "")*document.getElementsByName('VIT_IFR_CUR_RAT')[0].value.replace(/,/g, "");
temp.INS=document.getElementsByName('VIT_INS_AMT_FCX')[0].value.replace(/,/g, "")*document.getElementsByName('VIT_INS_CUR_RAT')[0].value.replace(/,/g, "");
temp.OCT=document.getElementsByName('VIT_OTC_AMT_NMU')[0].value=document.getElementsByName('VIT_OTC_AMT_FCX')[0].value.replace(/,/g, "")*document.getElementsByName('VIT_OTC_CUR_RAT')[0].value.replace(/,/g, "");
temp.DED=document.getElementsByName('VIT_DED_AMT_FCX')[0].value.replace(/,/g, "")*document.getElementsByName('VIT_DED_CUR_RAT')[0].value.replace(/,/g, "");

const amt_inv = temp.INV;
const amt_efr = temp.EFR;
const amt_ifr = temp.IFR;
const amt_ins = temp.INS;
const amt_otc = temp.OTC;
const amt_ded = temp.DED;

//console.log('R_VAL_Stv amt_inv'+amt_inv);

let amt_cst = amt_efr+(amt_ifr+(amt_ins+(amt_otc)))-amt_ded;

let amt_cif = amt_inv+(amt_efr+(amt_ifr+(amt_ins+(amt_otc))))-(amt_ded);



temp.VIT_CST=amt_cst.toFixed(2);
temp.VIT_CIF=amt_cif.toFixed(2);

// adjustment rate

// double amt_stv = amt_cif;
let amt_stv = amt_cif;
let adj_rat = itm.VIT_ADJ.toString();
adj_rat=1*adj_rat.replace(/,/g, "");
if (adj_rat > 0) {
	amt_stv = amt_stv*adj_rat;
}

temp.VIT_STV=amt_stv.toFixed(2);

}//end func



export default R_VAL_Stv;


/*
		BigDecimal amt_inv, amt_efr, amt_ifr, amt_ins, amt_otc, amt_ded, amt_cst, amt_cif;
		amt_inv = new BigDecimal(removeCommas(vit.ds(INV).ds(AMT).de(NMU).getString("0").trim()));
		amt_efr = new BigDecimal(removeCommas(vit.ds(EFR).ds(AMT).de(NMU).getString("0").trim()));
		amt_ifr = new BigDecimal(removeCommas(vit.ds(IFR).ds(AMT).de(NMU).getString("0").trim()));
		amt_ins = new BigDecimal(removeCommas(vit.ds(INS).ds(AMT).de(NMU).getString("0").trim()));
		amt_otc = new BigDecimal(removeCommas(vit.ds(OTC).ds(AMT).de(NMU).getString("0").trim()));
		amt_ded = new BigDecimal(removeCommas(vit.ds(DED).ds(AMT).de(NMU).getString("0").trim()));

		amt_cst = new BigDecimal("0");
		amt_cst = amt_efr.add(amt_ifr.add(amt_ins.add(amt_otc))).subtract(amt_ded);
		amt_cif = new BigDecimal("0");
		amt_cif = amt_inv.add(amt_efr.add(amt_ifr.add(amt_ins.add(amt_otc)))).subtract(amt_ded);


		vit.de(CST).setDouble(amt_cst.doubleValue());
		vit.de(CST).changeOriginalContent();
		vit.de(CIF).setDouble(amt_cif.doubleValue());
		vit.de(CIF).changeOriginalContent();

		// adjustment rate

		// double amt_stv = amt_cif;
		BigDecimal amt_stv = new BigDecimal("" + amt_cif.doubleValue());
		BigDecimal adj_rat = new BigDecimal(removeCommas(vit.de(ADJ).getString("0").trim()));
		if (adj_rat.doubleValue() > 0) {
			amt_stv = amt_stv.multiply(adj_rat);
		}

		vit.de(STV).setDouble(amt_stv.doubleValue());
		vit.de(STV).changeOriginalContent();
*/